angular
	.module 'App.Repository'
	.factory 'CustomerDisplayMediaFileRepository', ['BaseRepository', (BaseRepository) ->
		class CustomerDisplayMediaFileRepository extends BaseRepository
			@resource = '/icd_media_files'
			@isRestricted = true

		return new CustomerDisplayMediaFileRepository
	]
